import { render, staticRenderFns } from "./ReviewsPage.vue?vue&type=template&id=1f547f5f&scoped=true"
import script from "./ReviewsPage.vue?vue&type=script&lang=js"
export * from "./ReviewsPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewsPage.vue?vue&type=style&index=0&id=1f547f5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f547f5f",
  null
  
)

export default component.exports